import { PayloadAction } from "@reduxjs/toolkit";
import { IActivityHistoryCustomFilterGroup } from "../../model";

export function addCustomFiltersReducer(
  state,
  action: PayloadAction<IActivityHistoryCustomFilterGroup>,
) {
  const exists = state.filters.some((filter) => filter.id === action.payload.id);

  if (!exists) {
    state.filters = [...state.filters, action.payload];
  }
}
